import React from "react";
import "./AboutSection.css"; // Add any custom styles here if needed
import img from "../../images/realoAboutUs.png"

const AboutSection = () => {
  return (
    <div className="about-section container my-5">
      <div className="row align-items-center">
        {/* Image Column - Reversed on smaller screens */}
        <div className="col-lg-6 order-lg-2 mb-4 mb-lg-0">
          <img
            src={img}
            alt="About Parkgate Estate"
            className="img-fluid rounded"
          />
        </div>

        {/* Text Column */}
        <div className="col-lg-6 order-lg-1">
          <div className="about-text">
            <div className="about-title mb-3">
              <div className="about-title-1">
                <h2>Rreth</h2>
              </div>
              <div className="about-title-2">
                <h1>REALO</h1>
                <h3>REAL-ESTATE</h3>
              </div>
            </div>
            <p>
              Mirë se vini në Realo Real Estate – vendi ku pasioni për pasuritë
              e paluajtshme dhe përkushtimi ndaj klientit bashkohen për të
              krijuar përvoja unike! Si një kompani e pavarur dhe lidere në
              treg, ne jemi krenarë të ndërtojmë marrëdhënie të forta me
              klientët tanë, bazuar në besueshmëri, profesionalizëm dhe suksese
              të vazhdueshme. Me një histori suksesi që daton prej vitesh, ne
              vazhdojmë të rritemi falë rekomandimeve të shumta dhe besnikërisë
              që kemi fituar.
            </p>
            <p>
              Ekipi ynë dinamik ndodhet në zemër të qytetit dhe mbulon zonat
              kryesore urbane dhe periferike, duke ju garantuar një shërbim të
              personalizuar për çdo nevojë tuajën.
            </p>
            <p>
              Për ne, çdo klient është unik, dhe ne përkushtohemi për të sjellë
              zgjidhjet më të mira dhe më të përshtatshme për secilin. Realo
              është zgjedhja e parë për ata që kërkojnë cilësi, përkujdesje dhe
              sukses në çdo bashkëpunim mes nesh!
            </p>
            <h5 style={{ fontFamily: "Text" }}>Prona juaj, Prioriteti jonë!</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
